import React, { useEffect, useState } from 'react'
import FileUpload from '../input/FileUpload'

const Avatar = ({src, fieldName, uploadUrl, onUploadSuccess, method="put", ...props}) => {
    
    return <div style={{position: "relative"}}>
        <img width={200} src={src} />
        {
            fieldName && uploadUrl &&
            <FileUpload 
                fieldName={fieldName}
                method={method}
                url={uploadUrl}
                onUploadSuccess={onUploadSuccess}
                accept=".jpg,.png"
                autoUpload
            />
        }
            
    </div>
}

export default Avatar